/**
 * As DUAS esteiras da Central de Solicitações — fonte única no frontend.
 *
 * A tabela `aawz_servicos_solicitacoes` hospeda as duas desde a migration v619:
 * 'estrategico' (Central de Solicitações / AAWZ Hub, comportamento
 * pré-existente) e 'backoffice' (Wealth Service). Espelha o enum do backend em
 * `aawz_solicitacoes/core/classificacao_filtro.py:CLASSIFICACOES_VALIDAS`.
 *
 * PARIDADE (a regra que explica o default): onde o parâmetro `classificacao`
 * não vai, o backend assume ESTRATÉGICO — para que quem já usava o Hub não veja
 * nada mudar. Toda leitura da esteira Backoffice manda o valor explícito.
 *
 * Existia como `const` local em `ws/api/apiWsSolicitacoes.js` e em
 * `solicitacoes/api/apiCatalogoBackoffice.js`; a terceira cópia (o seletor de
 * esteira da fila interna) virou o motivo de centralizar — duas listas paralelas
 * divergem em silêncio.
 */
export const CLASSIFICACAO_ESTRATEGICO = 'estrategico'
export const CLASSIFICACAO_BACKOFFICE = 'backoffice'

export const CLASSIFICACOES_VALIDAS = [
  CLASSIFICACAO_ESTRATEGICO,
  CLASSIFICACAO_BACKOFFICE,
]

// Rótulos de UI. "Estratégico" é o nome que o Hub sempre usou; "Backoffice" é o
// nome da esteira do Wealth Service — os dois aparecem no seletor da fila da
// Operação AAWZ.
export const CLASSIFICACAO_LABELS = {
  [CLASSIFICACAO_ESTRATEGICO]: 'Estratégico',
  [CLASSIFICACAO_BACKOFFICE]: 'Backoffice',
}

export const CLASSIFICACAO_OPTIONS = CLASSIFICACOES_VALIDAS.map((value) => ({
  value,
  label: CLASSIFICACAO_LABELS[value],
}))
